import { render, staticRenderFns } from "./MembershipMatches.vue?vue&type=template&id=6a89050c&scoped=true"
import script from "./MembershipMatches.vue?vue&type=script&lang=js"
export * from "./MembershipMatches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a89050c",
  null
  
)

export default component.exports